import { Container } from 'inversify'

import { SoccerIncidentId } from '@collector/sportsapi-client-legacy'

import { SoccerRelationIoCBindings } from './SoccerRelationDependencies'

export function bindIncidentSequencesEnabledWithSameTime(ioc: Container): void {
  ioc
    .bind(SoccerRelationIoCBindings.EnabledIncidentSequencesWithSameTime)
    .toDynamicValue(() => {
      return [
        [SoccerIncidentId.Foul, SoccerIncidentId.FreeKick],
        [SoccerIncidentId.Offside, SoccerIncidentId.FreeKick],
        [SoccerIncidentId.Foul, SoccerIncidentId.Penalty],
      ]
    })
    .inSingletonScope()
}
